var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"13","height":"14","fill":"none"}},[_c('path',{attrs:{"fill":"#719C65","d":"M1.3 9.47 0 13.5l4.03-1.3L1.3 9.47ZM8.556 2.193 2.213 8.535l2.758 2.758 6.342-6.343-2.757-2.757ZM12.805 2.515l-1.82-1.82a.628.628 0 0 0-.91 0l-.585.585 2.73 2.73.585-.585c.26-.26.26-.65 0-.91Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }